// src/services/broadcastApi.ts
import apiReq from 'core/api';
import type { BroadcastPollResponse } from 'events/types';

/**
 * HTTP-фолбэк к WebSocket-уведомлениям. Отдаёт журнал терминальных событий
 * (events) после переданного cursor + снапшот живых STREAM-задач (task_states).
 *
 * Транспорт-уровневые статусы обрабатываются вызывающим (контроллер polling):
 *  - 401 — apiReq сам редиректит на /login (истёкшая сессия);
 *  - 422 — невалидный cursor (баг фронта) → сбросить cursor;
 *  - 503 — Redis недоступен → backoff-ретрай, НЕ сбрасывать cursor.
 *
 * @param cursor opaque-курсор последнего полученного события; null → replay TTL-окна.
 */
export const pollBroadcast = async (cursor: string | null): Promise<BroadcastPollResponse> => {
  const path = cursor ? `broadcast/poll?cursor=${encodeURIComponent(cursor)}` : 'broadcast/poll';

  const res = await apiReq<BroadcastPollResponse>(path, 'GET');

  // apiReq бросает на не-2xx, поэтому undefined тут означает пустое тело 2xx —
  // отдаём безопасный пустой снапшот, чтобы цикл polling не падал.
  return res ?? { cursor, events: [], task_states: {} };
};
